import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
console.log("API_URL:", process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");

    // Get condition and instanceId from spiders_session (per-tab)
    let sessionCondition = null;
    let sessionInstanceId = null;
    try {
      const session = sessionStorage.getItem("spiders_session");
      if (session) {
        const sessionData = JSON.parse(session);
        sessionCondition = sessionData.conditionId;
        sessionInstanceId = sessionData.instanceId;
      }
    } catch (e) {
      console.error("Error reading session data:", e);
    }

    // Fall back to legacy condition storage
    const legacyCondition = sessionStorage.getItem("condition");
    const condition = sessionCondition || legacyCondition;
    const instanceId = sessionInstanceId;

    console.log("Full request URL:", config.baseURL + config.url);
    console.log("Condition:", condition, "InstanceId:", instanceId);

    // Only set user token if Authorization header isn't already explicitly set
    // (e.g., admin dashboard sets its own admin token)
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add condition and instanceId to all requests as fallbacks
    // Explicit values in the request take precedence over session values
    if (config.method === "get") {
      config.params = config.params || {};
      // Only add fallbacks if not explicitly set (check for undefined, not just falsy)
      if (config.params.condition === undefined && condition) {
        config.params.condition = condition;
      }
      if (config.params.instanceId === undefined && instanceId) {
        config.params.instanceId = instanceId;
      }
    } else if (config.data) {
      // For POST/PUT/PATCH, only add fallbacks if not explicitly provided
      if (config.data.condition === undefined && condition) {
        config.data.condition = condition;
      }
      if (config.data.instanceId === undefined && instanceId) {
        config.data.instanceId = instanceId;
      }
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API response error:", error.response?.data || error.message);

    // Handle expired admin token: if an admin request gets 401, redirect to admin login
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const isAdminRequest = requestUrl.includes("/admin/") ||
        error.config?.headers?.Authorization === `Bearer ${localStorage.getItem("admin_token")}`;

      if (isAdminRequest && localStorage.getItem("admin_token")) {
        console.warn("Admin token expired, redirecting to login...");
        localStorage.removeItem("admin_token");
        // Only redirect if currently on an admin page
        if (window.location.pathname.startsWith("/admin") && !window.location.pathname.includes("/admin/login")) {
          window.location.href = "/admin/login";
        }
      }
    }

    return Promise.reject(error);
  }
);

api.recordInteraction = async (userId, type, targetId) => {
  let condition = null;
  let instanceId = null;
  try {
    const session = sessionStorage.getItem("spiders_session");
    if (session) {
      const sessionData = JSON.parse(session);
      condition = sessionData.conditionId;
      instanceId = sessionData.instanceId;
    }
  } catch (e) {
    console.error("Error reading session:", e);
  }

  // Fall back to legacy condition storage
  if (!condition) {
    condition = sessionStorage.getItem("condition");
  }

  console.log("Recording interaction:", { userId, type, targetId, condition, instanceId });
  if (!userId) {
    console.error("UserId is undefined. Cannot record interaction.");
    return;
  }
  try {
    const response = await api.post(`/interactions/${userId}`, {
      type,
      targetId,
      condition,
      instanceId,
    });
    console.log("Interaction recorded successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error recording ${type} interaction:`, error);
    throw error;
  }
};

api.startSession = async () => {
  try {
    const response = await api.post("/session/start-session");
    console.log("Session started successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error starting session:", error);
    throw error;
  }
};

api.endSession = async () => {
  try {
    const response = await api.post("/session/end-session");
    console.log("Session ended successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error ending session:", error);
    throw error;
  }
};

export default api;
